import React from 'react'
import { AppConfigCodec } from '@amzn/aapn-front-end-config-lib'
import * as io from 'io-ts/es6'

export const CrowdSurfConfigCodec = io.intersection([
  AppConfigCodec,
  io.type({
    hostname: io.string,
    stage: io.union([io.literal('dev'), io.literal('alpha'), io.literal('beta'), io.literal('gamma'), io.literal('prod')]),
    metricsEndpoint: io.intersection([
      io.type({
        stage: io.string,
        site: io.string,
        app: io.string,
      }),
      io.partial({
        user: io.string,
        realm: io.string,
      }),
    ]),
    authentication: io.type({
      authPortalEndpoint: io.string,
      apiEndpoint: io.string,
      apiClientId: io.string,
      apiMarketplaceId: io.string,
    }),
    leadsApiEndpoint: io.string,
    experimentationApiEndpoint: io.string,
    caseStudiesApiEndpoint: io.string,
  }),
  io.partial({
    authAuthority: io.string,
    authClientId: io.string,
  }),
])

export type CrowdSurfConfig = io.TypeOf<typeof CrowdSurfConfigCodec>

//The default value cannot be provided as undefined here like it is in AAPNFrontEndConfigLib b/c our tsconfig is set to 'strict' in AAPNCrowdSurf
//See https://kentcdodds.com/blog/how-to-use-react-context-effectively for more details on how to avoid issues with skipping default values with React context.
export const CrowdSurfConfigContext = React.createContext<CrowdSurfConfig>({
  apiEndpoint: '',
  authRedirectUrl: '',
  hostname: '',
  stage: 'dev',
  authAuthority: '',
  authClientId: '',
  authentication: {
    authPortalEndpoint: '',
    apiEndpoint: '',
    apiClientId: '',
    apiMarketplaceId: '',
  },
  leadsApiEndpoint: '',
  experimentationApiEndpoint: '',
  caseStudiesApiEndpoint: '',
  metricsEndpoint: {
    stage: 'dev',
    site: 'AAPN',
    app: 'AAPNCrowdSurf',
  },
})
